import AiResult from './AiResult';
import './AiResult.scss';

export default AiResult;